import { redirect } from './index'

export const logout = async (redirect_url: string) => {
  try {
    await localStorage.removeItem('authToken')

    redirect(redirect_url)
  } catch (e) {
    console.error('Error: logout', e)
  }
}

// Token related
export const authenticateToken = () => {
  const token = localStorage.getItem('authToken')
  if (token) {
    return token
  }
  return false
}

export const setAuthToken = (token: string) => {
  try {
    localStorage.setItem('authToken', token)
    return true
  } catch (e) {
    console.error('Error: Token set', e)
    return false
  }
}

export const removeAuthToken = () => {
  try {
    localStorage.removeItem('authToken')
    return true
  } catch (e) {
    console.error('Error: Token remove', e)
    return false
  }
}
